export const ERROR_UNAUTHORIZED = 'Unauthorized';

export const ERROR_MISSING_ITEM_IN_ORDER = 'В заказе есть отсутствующий продукт';
